
import React from 'react';

interface NavbarLogoProps {
  onClick: () => void;
}

const NavbarLogo = ({ onClick }: NavbarLogoProps) => {
  return (
    <div 
      onClick={onClick} 
      className="font-serif text-xl md:text-2xl font-medium cursor-pointer"
    >
      SUMSAE
    </div>
  );
};

export default NavbarLogo;
